import DesignECardView from './DesignECardView';

export default DesignECardView;
